import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { getToken, deleteCatch } from '@/utils/cache'
import Router from '@/router/index'
import { BASEURL, initBaseURL, isExe, recoverBaseURL } from '@/utils/realmName'
import { publishBackendQuotes, quoteRequestStamp } from './stockQuoteFeed'

// create an axios instance
const service = axios.create({
  baseURL: BASEURL(), // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
  // headers:{
  //   Authorization: getToken()
  // }
})

let sessionExpired = false
let expiredToken = ''
let logoutPrompt = null
const authError = () => Object.assign(new Error('登录已失效，请确认退出后重新登录'), { isAuthExpired: true })
const isUnauthorized = res => res && (Number(res.code) === 401 || (Number(res.code) === 0 && Number(res.mes) === 401))

function expireSession(config) {
  // Ignore an old session's late response after logout or a new login.
  const requestToken = config && config.headers && config.headers.Authorization
  if (requestToken && requestToken !== getToken()) return Promise.reject(authError())
  if (!sessionExpired) {
    sessionExpired = true
    expiredToken = getToken()
    logoutPrompt = MessageBox.alert('登录信息已失效，请确认退出并重新登录。', '登录失效', {
      confirmButtonText: '确认退出',
      type: 'warning',
      showCancelButton: false,
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      closeOnHashChange: false
    }).then(() => {
      deleteCatch('TOKEN')
      deleteCatch('userInfo')
      return Router.replace('/login').catch(() => {})
    }).catch(() => {}).finally(() => { logoutPrompt = null })
  }
  return Promise.reject(authError())
}

// request interceptor
service.interceptors.request.use(
  async config => {
    config.baseURL = await initBaseURL()
    service.defaults.baseURL = config.baseURL
    const token = getToken()
    if (sessionExpired && !logoutPrompt && (!token || token !== expiredToken)) sessionExpired = false
    if (sessionExpired && !config.publicRequest) return Promise.reject(authError())
    if (token && !config.publicRequest) {
      config.headers['Authorization'] = token
    }
    config.quoteStamp = quoteRequestStamp()
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (!response.config.publicRequest && isUnauthorized(res)) return expireSession(response.config)
    if (sessionExpired && !response.config.publicRequest) return Promise.reject(authError())
    // Chat endpoints return top-level fields / a bare paginator, not the standard data envelope.
    if (response.config.rawResponse && res && (res.code === 200 || res.code === undefined)) return res
    if (response.config.authChallenge && [202, 203].includes(Number(res.code))) return res
    if (res.code !== 200) {
      if(res.code == 0){
        if (!response.config.silent && (response.config.successMessage || response.config.notifyFailure)) Message({ message: res.msg || (typeof res.mes === 'string' && res.mes) || '操作失败，请稍后重试', type: 'error', duration: 5000 })
        return 0
      }else {
        console.log('error',res)
        if (!response.config.silent) Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
        return 0;
      }

    } else { //console.log('success',res)
      if (response.config.successMessage && !response.config.silent) {
        const text = typeof res.data === 'string' && res.data.trim() ? res.data : res.msg
        Message({ message: text && !/^(success|ok)$/i.test(text) ? text : response.config.successMessage, type: 'success', duration: 5000 })
      }
      publishBackendQuotes(response.config, res.data)
      return res.data
    }
  },
  async error => {
    const publicRequest = error.config && error.config.publicRequest
    const config = error.config
    if (isExe() && config && !config.domainRetried && error.response && error.response.status === 404 && !/^https?:\/\//i.test(config.url || '')) {
      config.domainRetried = true
      await recoverBaseURL(config.baseURL)
      return service(config)
    }
    if (error.isAuthExpired || (sessionExpired && !publicRequest)) return Promise.reject(error.isAuthExpired ? error : authError())
    if (!publicRequest && error.response && (error.response.status === 401 || isUnauthorized(error.response.data))) return expireSession(error.config)
    console.log('err' + error) // for debug
    if (!(error.config && error.config.silent)) Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
